module.exports = __webpack_public_path__ + "static/img/honor_2.7dc68de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/honor_2.png
// module id = /EIz
// module chunks = 15